import { ErroApi } from './api';

/** Texto amigável para mostrar ao usuário a partir de qualquer erro. */
export function mensagemDeErro(erro: unknown): string {
  if (erro instanceof ErroApi) return erro.message;
  return 'Algo deu errado. Tente novamente.';
}
